import { boolean, literal, object } from "zod";

export const disconnectIDFShippingIntegration = {
  name: "disconnectIDFShippingIntegration" as const,
  input: literal(null),
  output: object({ success: boolean() }),
};
